import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import ShareIcon from '@mui/icons-material/Share';
import {Box, Grid} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedButton from '../../components/button/button';
import {IListItem} from '../../components/card/listItem/IListItem';
import SqureCard from '../../components/card/squreCard/squreCard';
import BottomDrawer from '../../components/drawer/bottomDrawer';
import EmptyStyle from '../../components/emptyStyles/emptyStyle';
import {WALLET_KEY} from '../../config/cacheKey';
import {IGetCustomerWalletsInfoResponse} from '../../models/wallet.model';
import {setHeaderTitle} from '../../redux/headerTitle/headerTitleSlice';
import {getpervStateTab} from '../../redux/loansTab/loansTabSlice';
import {
    GetCustomerWalletInfo,
    GetCustomerWalletsInfo,
} from '../../services/wallet.service';
import CardCarousel from './carousel';
import WalletSkeleton from './walletSkeleton';
import EmptyLoanStyle from '../../components/icons/EmptyLoanStyle';

const walletItems = [
    {
        title: 'خرید حضوری',
        status: 'بارکد پرداخت',
        enumStatus: 'offline',
        icon: <LocalGroceryStoreOutlinedIcon />,
        id: 0,
    },
    {
        status: 'گردش مالی کیف',
        title: 'گردش کیف پول',
        enumStatus: 'walletFlow',
        icon: <CurrencyExchangeIcon />,
        id: 1,
    },
    {
        status: 'اشتراک کیف با دیگران',
        title: 'اشتراک کیف پول',
        enumStatus: 'share',
        icon: <ShareIcon />,
        id: 2,
    },
    {
        status: 'فروشندگان و محصولات متصل به کیف',
        title: 'دسته‌بندی محصولات',
        enumStatus: 'store',
        icon: <Groups2OutlinedIcon />,
        id: 3,
    },
];
export default function Wallet({setTabChild, setState}: any) {
    const queryClient = useQueryClient();
    const [customerWallets, setCustomerWallets] =
        useState<IGetCustomerWalletsInfoResponse[]>();
    const dispatch = useDispatch();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [noServiceText, setNoServiceText] = useState('خرید حضوری');

    const {mutate: GetCustomerWalletsInfoMutate, isLoading} = useMutation(
        GetCustomerWalletsInfo,
        {
            onSuccess: (data: IGetCustomerWalletsInfoResponse[]) => {
                if (data) {
                    setCustomerWallets(data);
                    queryClient.setQueryData(WALLET_KEY, data[0].key);
                    queryClient.setQueryData('wallets', data);
                }
            },
            onError: () => {},
        }
    );
    const {mutate: GetCustomerWalletInfoMutate, isLoading: walletInfoLoading} =
        useMutation(GetCustomerWalletInfo, {
            onSuccess: (data: IGetCustomerWalletsInfoResponse) => {
                if (data) {
                    setCustomerWallets(
                        customerWallets?.map((wallet) =>
                            wallet.key === data.key ? data : wallet
                        )
                    );
                    const wallets: IGetCustomerWalletsInfoResponse[] =
                        queryClient.getQueryData('wallets') || [];
                    queryClient.setQueryData(
                        'wallets',
                        wallets.map((item: IGetCustomerWalletsInfoResponse) =>
                            item.key === data.key ? data : item
                        )
                    );
                }
            },
            onError: () => {},
        });
    const handleWalletClick = (enumStatus: string) => {
        if (enumStatus === 'walletFlow') {
            setState('purchaseRecords');
        } else if (enumStatus === 'store') {
            setState('store');
        } else if (enumStatus === 'offline') {
            setOpenDrawer(true);
            setNoServiceText('خرید حضوری');
        } else if (enumStatus === 'share') {
            setOpenDrawer(true);
            setNoServiceText('اشتراک کیف');
        }
    };
    const handleReloadBalance = (key: string) => {
        queryClient.setQueryData(WALLET_KEY, key);
        GetCustomerWalletInfoMutate({
            walletKey: key,
        });
    };

    const handleRequestLoan = () => {
        setTabChild(2);
        dispatch(getpervStateTab({prevState: 'loans'}));
    };

    useEffect(() => {
        dispatch(
            setHeaderTitle({
                header: 'کیف پول',
                color: 'var(--header-color)',
            })
        );
        GetCustomerWalletsInfoMutate();
    }, []);

    if (isLoading) {
        return <WalletSkeleton />;
    }

    if (!isLoading && customerWallets?.length === 0) {
        return (
            <div
                style={{height: '100%'}}
                className="content-container p-5 mt-5 !h-[calc(100svh-130px)]"
            >
                <div>
                    <EmptyStyle
                        text='"کیف پول" فعالی یافت نشد.'
                        emphasisedWords={['کیف پول']}
                        emphasisedWordsColor="#BBA57A"
                        icon={
                            <EmptyLoanStyle className="text-[var(--primary-text-color)]" />
                        }
                    />
                </div>
                <div className="w-full py-5 sm:pt-4 pb-8">
                    <CustomisedButton
                        title="ثبت درخواست تسهیلات"
                        disable={false}
                        onClick={handleRequestLoan}
                        type="button"
                    />
                </div>
            </div>
        );
    }

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{
                    width: '100%',
                    margin: '0',
                    height: 'calc(100svh - 140px)',
                }}
            >
                <Grid
                    xs={12}
                    sx={{
                        background: 'var(--header-color)',

                        borderBottom: '1px solid var(--border-color)',
                        height: '40%',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <CardCarousel
                        setTempWalletKey={() => {}}
                        customerWallets={customerWallets!}
                        reloadBalance={handleReloadBalance}
                        walletInfoLoading={walletInfoLoading}
                    />
                </Grid>
                <Box
                    display="flex"
                    gap={'10px'}
                    flexWrap="wrap"
                    sx={{
                        margin: 'auto',
                        marginTop: '10px',
                        flex: 1,
                        paddingInline: '20px',
                        justifyContent: 'center',
                        maxHeight: '60%',
                        overflowY: 'auto',
                        alignItems: 'center',
                    }}
                >
                    {walletItems.map((item: IListItem, index: number) => (
                        <SqureCard
                            title={item.title}
                            status={item.status}
                            icon={item.icon}
                            id={index}
                            onClick={() => handleWalletClick(item.enumStatus!)}
                            enumStatus={item.enumStatus}
                            key={index}
                        />
                    ))}
                </Box>
            </Grid>
            <BottomDrawer
                open={openDrawer}
                setOpen={setOpenDrawer}
                title={noServiceText}
                text={
                    noServiceText === 'خرید حضوری'
                        ? `برای خرید حضوری به یکی از فروشندگان حضوری طرف قرارداد مراجعه کنید.`
                        : `در حال حاضر امکان ${noServiceText} از طریق این کیف پول فعال نمیباشد.`
                }
            />
        </>
    );
}
